import { Clear as ClearIcon } from 'components/icons';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from 'components/ui/input-group';
import { ChangeEvent, useState } from 'react';
import { t } from 'utils/getTranslations';

/**
 * A drawer filter's text field with a clear button that shows while the pointer is over a field that
 * holds something. The button keeps the field's focus: it is pressed without the input blurring.
 */
export function ClearableInput({
    value,
    placeholder,
    ariaLabel,
    onChange,
    onClear,
}: {
    value: string;
    placeholder: string;
    ariaLabel?: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
}) {
    const [hovered, setHovered] = useState(false);
    return (
        <InputGroup className="bg-paper" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
            <InputGroupInput value={value} placeholder={placeholder} aria-label={ariaLabel} onChange={onChange} />
            {value !== '' && hovered ? (
                <InputGroupAddon align="inline-end">
                    <InputGroupButton
                        size="icon-xs"
                        aria-label={t('clear')}
                        className="text-fg-secondary"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={onClear}
                    >
                        <ClearIcon className="size-4" />
                    </InputGroupButton>
                </InputGroupAddon>
            ) : null}
        </InputGroup>
    );
}
